module.exports = __webpack_public_path__ + "static/media/background.4f174108.jpg";